import styled from 'styled-components/macro';

import { deviceMax } from 'utils/styles/breakpoints';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const Wrapper = styled.div`
  margin: 0 auto;
  ${FLEX_CONTAINER.FlexCenterColumn}

  @media ${deviceMax.tablet} {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
